// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { h } from '@stencil/core';
import { AssetAddiLogoSvgUrl } from '@addi/ds-legacy/util-tokens/pkg';
import { WidgetStyle } from '../../addi-product-widget/addi-product-widget.d';
import { BannerConfig } from '../../addi-product-banner/addi-product-banner.d';

const BANNER_GRANDE_THRESHOLD = 900_000;

const renderBadge = (
  customBannerStyle: WidgetStyle,
  showSkeleton: boolean
): HTMLElement => (
  <div class="addi-banner-bagde addi-banner-custom-bagde">
    {renderBadgeIcon(customBannerStyle, showSkeleton)}
  </div>
);

const renderBadgeIcon = (
  customBannerStyle: WidgetStyle,
  showSkeleton: boolean
): HTMLElement => {
  const skeletonClass = showSkeleton ? 'loading' : '';
  const iconClass = `addi-banner-bagde__icon--${customBannerStyle?.iconType}`;
  const customStyles = customBannerStyle?.iconSize
    ? {
        width: customBannerStyle.iconSize,
        height: customBannerStyle.iconSize,
        display: 'block',
      }
    : {};

  return (
    <div class={`${iconClass} ${skeletonClass}`} style={customStyles}></div>
  );
};

const renderInfo = (
  config: BannerConfig,
  showSkeleton: boolean
): HTMLElement => {
  let message = '';
  if (!showSkeleton) {
    message = generateMessageV2(config);
  }

  return (
    <div class="addi-banner-info addi-banner-custom-info">
      <div class={`addi-banner-info__message ${showSkeleton ? 'loading' : ''}`}>
        {message}
      </div>
    </div>
  );
};

const generateMessageV2 = ({ id: widgetId, proposal }: BannerConfig) => {
  if (proposal.amount < BANNER_GRANDE_THRESHOLD) {
    return (
      <div>
        Paga con {getAddiLogoString()} en
        <strong class="addi-banner-info__message--strong">
          {'  '} hasta {proposal.term} cuotas
        </strong>
        {'.   '}
        &nbsp;
        <button
          id={`show-more-btn_${widgetId}`}
          class="addi-banner-button addi-banner-button--link"
        >
          {' '}
          Pide un cupo{' '}
        </button>
      </div>
    );
  } else {
    return (
      <div>
        Paga esta compra con {getAddiLogoString()} desde{' '}
        <strong class="addi-banner-info__message--strong">
          {' '}
          6 hasta {proposal.term} cuotas
        </strong>
        .{' '}
        <button
          id={`show-more-btn_${widgetId}`}
          class="addi-banner-button addi-banner-button--link"
        >
          {' '}
          Conoce más{' '}
        </button>
      </div>
    );
  }
};

const getAddiLogoString = (): string => (
  <img class="addi-banner-info__addi-logo" src={AssetAddiLogoSvgUrl} />
);

const buildBanner = (config: BannerConfig): HTMLElement => {
  const showSkeleton = !config.id;
  const badgeComponent = renderBadge(config.customBannerStyle, showSkeleton);
  const infoComponent = renderInfo(config, showSkeleton);

  return (
    <div class="addi-banner-wrapper">
      <div
        id={`addi-banner_${config.id}`}
        class={`addi-banner addi-banner-custom ${
          config?.proposal?.discount && 'addi-banner--with-discount'
        }`}
      >
        {badgeComponent}
        {infoComponent}
      </div>
    </div>
  );
};

export const BnplDefaultTemplate = (config: BannerConfig): HTMLElement => {
  const bannerComponent = buildBanner(config);

  return (
    <div>
      {config?.proposal?.discount ? (
        <div class="addi-banner-discount addi-banner-custom-discount">
          {config.proposal.discount * 100}% de descuento extra
        </div>
      ) : (
        ''
      )}
      {bannerComponent}
    </div>
  );
};

export const BNPLWidgetProspectDiscount = (
  config: BannerConfig
): HTMLElement => {
  const bannerComponent = buildBanner(config);

  return (
    <div>
      {config?.proposal?.discount ? (
        <div class="addi-banner-discount addi-banner-custom-discount">
          {config.proposal.discount * 100}% de descuento extra para nuevos
          usuarios de Addi
        </div>
      ) : (
        ''
      )}
      {bannerComponent}
    </div>
  );
};
